/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export default class Autoreload extends Controller {
	public interval: ReturnType<typeof setInterval> | null;
	public initial_path: string;
	static values = {
		url: String,
		delay: Number,
	};

	declare urlValue: string;
	declare delayValue: number;

	private id = Math.random().toString(36).slice(2);

	connect() {
		this.startInterval();
	}

	startInterval() {
		this.interval = setInterval(() => {
			this.tick();
		}, this.delayValue);
	}

	delayValueChanged() {
		if (this.interval) {
			this.stopInterval();
			this.startInterval();
		}
	}

	tick = () => {
		if (window.location.pathname != this.urlValue) {
			this.stopInterval();
			return;
		}
		Turbo.visit(window.location.href, { action: "replace" });
	};

	stopInterval() {
		clearInterval(this.interval);
	}

	disconnect() {
		this.stopInterval();
	}
}
